export default __webpack_public_path__ + "static/media/eth.5d6e39aa.png";